import { render, staticRenderFns } from "./productListFirst.vue?vue&type=template&id=5d68b1cd&scoped=true"
import script from "./productListFirst.vue?vue&type=script&lang=js"
export * from "./productListFirst.vue?vue&type=script&lang=js"
import style0 from "./productListFirst.vue?vue&type=style&index=0&id=5d68b1cd&prod&scoped=true&lang=less"
import style1 from "@/assets/h5css/mobile/productListFirst.less?vue&type=style&index=1&id=5d68b1cd&prod&scoped=true&lang=less&external"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d68b1cd",
  null
  
)

export default component.exports